import { useMemo } from "react";

import { Dropdown, DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { GrowthOverviewMetric, GROWTH_OVERVIEW_QUERY_KEY } from "../const";
import { useGrowthOverviewContext } from "../context/GrowthOverviewProvider";
import { GROWTH_OVERVIEW_METRIC_LABEL_KEYS } from "../growthOverviewTexts";

export const MetricDropdown = () => {
    const { metric, setMetric } = useGrowthOverviewContext();
    const metricOptions = useMemo(
        () =>
            [GrowthOverviewMetric.Visits, GrowthOverviewMetric.Unique].map((id) => ({
                id,
                text: translate(GROWTH_OVERVIEW_METRIC_LABEL_KEYS[id]),
            })),
        [],
    );
    const selectedLabel = translate(GROWTH_OVERVIEW_METRIC_LABEL_KEYS[metric]);

    return (
        <Box data-automation={`${GROWTH_OVERVIEW_QUERY_KEY}-metric-dropdown`}>
            <Dropdown
                appendTo="body"
                hasSearch={false}
                width={160}
                buttonWidth={160}
                dropdownPopupPlacement="bottom-right"
                selectedIds={{ [metric]: true }}
                closeOnItemClick
                itemsComponent={SimpleDropdownItem}
                onClick={({ id }) => setMetric(id as GrowthOverviewMetric)}
            >
                {[
                    <DropdownButton
                        key="growth-overview-metric-dropdown-button"
                        width={160}
                    >
                        {selectedLabel}
                    </DropdownButton>,
                    ...metricOptions.map((option) => ({
                        key: option.id,
                        id: option.id,
                        text: option.text,
                        selected: option.id === metric,
                    })),
                ]}
            </Dropdown>
        </Box>
    );
};
